<template>
	<!-- 所有考试信息 -->
	<div class="home" v-if="showExam">

		<!-- 顶部工具栏：搜索、添加、导出 -->
		<div class="search_line">
			<div class="first_search_line">
				<el-autocomplete v-if="userType=='admin'" class="auto_comp" clearable
					v-model="exam_search_data.school_name" :fetch-suggestions="querySearch" :trigger-on-focus="false"
					size="mini" placeholder="学校" />
				<el-select style="width: 200px;margin-left: 20px;margin-right: 20px;" v-model="exam_search_data.level" clearable
					placeholder="学历" size="mini">
					<el-option v-for="item in ['初中','高中']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
				<el-tooltip style="width: 200px;margin-right: 20px;" effect="dark" content="如: 2020"
					placement="top-start">
					<el-input clearable v-model="exam_search_data.grade" :trigger-on-focus="false" size="mini"
						placeholder="年级" />
				</el-tooltip>
				<el-select style="width: 200px;margin-right: 20px;" v-model="exam_search_data.major" clearable
					placeholder="专业" size="mini">
					<el-option v-for="item in major_options" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
				<el-input style="width: 200px;margin-right: 20px;" clearable v-model="exam_search_data.class_name"
					:trigger-on-focus="false" size="mini" placeholder="班级" />
				<el-input style="width: 200px;margin-right: 20px;" v-if="userType!='teacher'" clearable
					v-model="exam_search_data.teacher_name" :trigger-on-focus="false" size="mini" placeholder="教师姓名" />
<!-- 				<el-input style="width: 200px;margin-right: 20px;" clearable v-model="exam_search_data.create_time"
					:trigger-on-focus="false" size="mini" placeholder="时间" /> -->
				<el-date-picker style="width: 600px;margin-right: 20px;" v-model="exam_search_data.range_time" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" size="mini" value-format="yyyy.MM.dd">
				</el-date-picker>
			</div>
			<div class="second_search_line">
				<el-button class="search_bt" type="danger" icon="el-icon-search" size="mini" @click="getExams()">
					搜索
				</el-button>
			</div>
		</div>

		<!-- 内容表格 -->
		<el-table :data="tableData" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
			<el-table-column prop="name" label="考试名称" />
			<el-table-column prop="teacher_name" label="教师" />
			<el-table-column prop="className" label="班级" />
			<el-table-column prop="grade" label="年级" />
			<el-table-column prop="school_name" label="学校" width="250" />
			<el-table-column prop="createTime" label="考试时间" width="200" />

			<el-table-column prop="edit" label="查看" width="60">
				<template slot-scope="scope">
					<el-button @click="handleView(scope.row)" type="text" size="mini" class="edit_bt"><i
							class="el-icon-view"></i></el-button>
				</template>
			</el-table-column>

			<el-table-column prop="delete" :label="showDelete" width="60">
				<template slot-scope="scope">
					<el-button @click="handleDelete(scope.row)" type="text" size="mini" class="delete_bt"    v-if="userinfo.permit!='1'"><i
							class="el-icon-delete"></i></el-button>
				</template>
			</el-table-column>

		</el-table>

		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
				:total="total_num">
			</el-pagination>
		</div>


	</div>

	<!-- 该场考试分数 -->
	<div class="home" v-else="showExam">
		<!-- 顶部工具栏：搜索、添加、导出 -->
		<div class="search_line">
			<div class="first_search_line">
				<el-input style="width: 200px;margin-right: 20px;" clearable
					v-model="score_search_data.sid" :trigger-on-focus="false" size="mini" placeholder="学号" />
				<el-input style="width: 200px;margin-right: 20px;" clearable v-model="score_search_data.student_name"
					:trigger-on-focus="false" size="mini" placeholder="姓名" />
				<el-select style="width: 200px;margin-right: 20px;" v-model="score_search_data.male" clearable
					placeholder="性别" size="mini">
					<el-option v-for="item in ['男','女']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
			<div class="second_search_line">
				<el-button class="search_bt" type="danger" icon="el-icon-d-arrow-left" size="mini" @click="back()">
					返回
				</el-button>
				<el-button class="search_bt" type="primary" icon="el-icon-search" size="mini" @click="getScores()">
					搜索
				</el-button>
				<el-button class="search_bt" type="success" icon="el-icon-download" size="mini" @click="exportScore()">
					导出
				</el-button>
				<el-button class="search_bt" type="success" icon="el-icon-download" size="mini" @click="exportZx()">
					导出专项成绩
				</el-button>
				<el-select style="width: 150px;margin-left: 5px" v-model="exportZX" clearable
					placeholder="选择要导出的专项" size="mini">
					<el-option v-for="item in ['篮球','足球','排球','体操','武术']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
		</div>

		<!-- 内容表格 -->
		<el-table :data="scoreData" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
			<el-table-column prop="sid" label="学号" width="150"/>
			<el-table-column prop="name" label="姓名" />
			<el-table-column prop="male" label="性别" />

			<el-table-column prop="total" label="总分" />

			<div v-for="item in items" :key="item">
				<el-table-column :prop="item" :label="item" />
			</div>
			



			<el-table-column prop="edit" label="各项分数" width="80">
				<template slot-scope="scope">
					<el-button @click="handleViewStudent(scope.row)" type="text" size="mini" class="delete_bt"><i
							class="el-icon-document"></i></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
				:total="total_num">
			</el-pagination>
		</div> -->


		<!-- 学生分数弹窗 -->
		<el-dialog :visible.sync="dialogstudentScoreVisible" top="5vh">
			<div>
				<p style="size: 50px;font-weight: bolder;">{{student.name}}: &nbsp; {{student.total}}分</p>
			</div>

			<el-table :data="scores" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
				<el-table-column prop="name" label="大项" />
				<el-table-column prop="subName" label="小项" />
				<el-table-column prop="result" label="成绩" />
				<el-table-column prop="score" label="分数" />
			</el-table>


			<div slot="footer" class="dialog-footer">
				<span v-show="showTip">
					<font>{{result}}</font>
				</span>
				<el-button size="small" type="primary" @click="dialogstudentScoreVisible = false">
					确 定
				</el-button>
			</div>
		</el-dialog>
	</div>





</template>

<script>
	export default {
		name: "Score",
		data() {
			return {
				showExam: true,
				exam_id: '',
				userType: window.localStorage.getItem("userType"),
				userinfo:'',
				exportZX:'',
				exam_search_data: {
					school_name: '',
					level: '',
					grade: '',
					major: '',
					class_name: '',
					teacher_name: '',
					create_time: '',
					range_time:''
				},
				score_search_data: {
					sid: '',
					student_name: '',
					male: ''
				},
				student: {
					name: '',
					total: '',
				},
				scores: [],
				major_options: ['田径', '体操', '足球', '篮球', '武术', '排球', '游泳'],
				tableData: [],
				scoreData: [],
				items: [],
				total_num: 0,
				dialogteacherAddVisible: false,
				showTip: false,
				result: '',
				dialogteacherEditVisible: false,
				dialogImportStudentVisible: false,
				dialogstudentScoreVisible: false,
				file_list: [],
				showDelete: '删除',
			}
		},
		mounted() {
			this.getExams();
		},
		methods: {
			getExams(page, nums) {
				page = !page ? 1 : page
				nums = !nums ? 10 : nums
				const that = this
				var range_time = this.exam_search_data.range_time
				if(!range_time){
					range_time = [null,null]
				}
				let data = {
					userType: that.userType,
					page: page,
					nums: nums,
					school_name: this.exam_search_data.school_name,
					level: this.exam_search_data.level.substr(0, 1),
					grade: this.exam_search_data.grade,
					major: this.exam_search_data.major,
					class_name: this.exam_search_data.class_name,
					teacher_name: this.exam_search_data.teacher_name,
					start_time: range_time[0],
					end_time: range_time[1],
				}
				// 获取信息
				this.$axios({
					method: 'post',
					url: '/jfapi/getExams',
					data: that.qs.stringify(data),
				}).then(function(res) {
					// console.log(res.data)
					that.tableData = res.data.records
					that.total_num = res.data.total
				});

				// 获取用户信息
				that.$axios({
					url: '/jfapi/userinfo/' + that.userType
				}).then(function(res) {
					that.userinfo = res.data
					if(that.userinfo.permit == '1'){
						that.showDelete = ''
					}
				})
			},
			querySearch(queryString, cb) {
				this.$axios({
					url: '/jfapi/getSchollHint?queryString=' + queryString,
				}).then(function(res) {
					cb(res.data)
				});
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getExams(val)
			},
			import_dialog() {
				this.file_list = [];
				this.dialogImportStudentVisible = true;
			},
			down_student_templete() {
				window.location.href = "/jfapi/down_student_templete"
			},
			import_student() {
				this.$refs.upload.submit()
			},
			import_error() {
				this.$message({
					message: '上传失败，请检查格式是否与模板一致！',
					type: 'error'
				});

			},
			import_success() {
				this.$message({
					message: '上传成功！',
					type: 'success'
				});
				this.getStudentInfo();
				this.dialogImportStudentVisible = false;
			},
			clearList() {
				this.file_list = [];
			},
			handleView(row) {
				this.showExam = false
				this.exam_id = row.id
				this.getScores()
				var items = row.items
				items = items.replaceAll("\"", "").replace("[", "").replace("]", "").split(",")
				this.items = items
			},
			handleDelete(row) {
				var r = confirm("删除后不可恢复，请谨慎操作！确定删除吗？");
				if (r == true) {
					const that = this
					this.$axios({
						url: '/jfapi/delExam?id=' + row.id + '&userType=' + that.userType,
					}).then(function(res) {
						that.getExams()
					});
				}
			},
			getScores() {
				let data = {
					userType: this.userType,
					id: this.exam_id,
					sid: this.score_search_data.sid,
					student_name: this.score_search_data.student_name,
					male: this.score_search_data.male,
				}
				var that = this
				// 获取分数
				this.$axios({
					method: 'post',
					url: '/jfapi/getExamResult',
					data: that.qs.stringify(data),
				}).then(function(res) {
					// console.log(res.data)
					that.scoreData = res.data
				});
			},
			back() {
				this.showExam = true
			},
			handleViewStudent(row) {
				this.student.name = row.name
				this.student.total = row.total
				let data = {
					stu_id: row.stu_id,
					examId: this.exam_id
				}
				// console.log(data)
				var that = this
				// 获取学生各项分数
				this.$axios({
					method: 'post',
					url: '/jfapi/score/get_Scores',
					data: that.qs.stringify(data),
				}).then(function(res) {
					// console.log(res.data)
					that.scores = res.data
					that.dialogstudentScoreVisible = true
				});
			},
			exportScore() {
				window.location.href = '/jfapi/exportScore?id=' + this.exam_id + '&userType=' + this.userType
			},
			exportZx(){
				if(this.exportZX == ""){
					this.$message({
						message: '请选择要导出的专项！',
						type: 'warning'
					});
					return;
				}
				window.location.href = '/jfapi/exportZx?id=' + this.exam_id + '&zx=' + this.exportZX +'&userType=' + this.userType
			}
		}
	};
</script>

<style lang="scss" scoped>
	.search_line {
		display: flex;
		width: 90%;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-left: 10px;
		padding-right: 10px;
	}

	.first_search_line {
		width: 100%;
		display: flex;
		margin-left: 22px;
		justify-content: flex-start;
	}

	.second_search_line {
		width: 80%;
		display: flex;
		justify-content: flex-start;
		margin-left: 18px;
		margin-top: 10px;
	}

	.auto_comp {
		width: 250px;
	}

	.auto_comp .el-input {
		width: 80%;
	}

	input {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.search_bt {
		margin-left: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.export_bt {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.el-table {
		margin-top: 10px;
		font-size: small;
		width: 96%;
		margin-left: 2%;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.edit_bt {
		color: #00ff7f;
	}

	.delete_bt {
		color: red;
	}

	.pagination {
		width: 90%;
		margin-left: 5%;
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}

	.input_title span {
		margin: 0;
		color: #959595;
		font-size: 10px;
	}

	.input_title {
		display: flex;
		justify-content: space-between;
		width: 80%;
		margin-left: 10%;
		margin-top: 10px;
	}

	.el-input__inner:focus {
		border-color: #00b27a;
	}

	.el-dialog__body {
		padding: 0;
	}

	.el-dialog {
		width: 40%;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.el-dialog .el-autocomplete {
		width: 100%;
	}

	font {
		color: #ff0000;
		margin-right: 10px;
	}

	.male_select {
		width: 100%;
		margin-left: 10%;
	}

	.el-dialog div .el-input {
		width: 80%;
	}

	.el-dialog div .el-select {
		width: 100%;
		margin-left: 10%;
	}
	
	[v-cloak] {
	  display: none !important;
	}
</style>
